// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_leave_note.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon-important-active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/icon-important-inactive.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__leaveNoteIcon___Ci7Ps {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 40px;
  transition: background-color 0.25s;
  width: 40px;
}

.styles__leaveNoteIcon___Ci7Ps:hover {
    background-color: #E1DFE1;
  }

.styles__collapseIcon___T_4w6 {
}

.styles__collapseRef___FMVZd {
}

.styles__collapseRef___FMVZd[data-active='true'] .styles__collapseIcon___T_4w6 {
      transform: rotate(180deg);
    }

.styles__dropdownArea___K_4_9 {
}

.styles__toggleLabel___bKnxf {
}

.styles__formItem___fQCDh textarea {
    min-height: 100px;
  }

.styles__formItem___fQCDh label {
    display: none;
  }

.styles__flexRow___m6cS3 {
}

.styles__flexSB___SnvLL {
}

.styles__note___OO52t {
  padding-bottom: 10px;
  font-weight: 500;
  white-space: pre-wrap;
}

.styles__notes___xDJ1e {
  list-style-type: none;
  margin: 0;
  overflow: auto;
  padding: 0;
}

.styles__noteWrapper___oCEFU {
  background: white;
  border-left: 4px solid gtYellow;
}

.styles__importantNoteWrapper___irbOP {
  background: #FDF1ED;
}

.styles__importantNoteWrapper___irbOP .styles__important___Nhxqi {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }

.styles__important___Nhxqi,
.styles__remove___YWFCu,
.styles__user___R_GFG {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__title___TUwX9 {
  flex: 1;
}

.styles__titleSection___xdY8M {
  position: relative;
}

.styles__titleSection___xdY8M:last-child {
    margin-bottom: 20px;
  }

.styles__titleSection___xdY8M .styles__name___VmXsh {
    transition: all 0.25s;
  }

.styles__titleSection___xdY8M .styles__noName___O10rr {
    margin-top: 2px;
  }

.styles__user___R_GFG {
  text-transform: capitalize;
}

.styles__important___Nhxqi {
  margin-right: 15px;
  background-position: center;
  background-size: 13px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  cursor: pointer;
}

.styles__important___Nhxqi a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

.styles__remove___YWFCu {
  margin-left: 4px;
  background-position: center;
  background-size: 11px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  cursor: pointer;
}

.styles__remove___YWFCu a {
    display: block;
    box-shadow: none;
    height: 100%;
    width: 24px;
  }

.styles__buttons___oIhFB {
  display: flex;
  justify-content: flex-end;
}

.styles__removeBtn___CkM3p {
}

.styles__cancelBtn___SGUQP {
  margin-left: 14px;
}
`, "",{"version":3,"sources":["webpack://./universal/components/Warnings/styles.css"],"names":[],"mappings":"AAIA;EACE,yDAAuD;EACvD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kCAAkC;EAClC,WAAW;AAKb;;AAHE;IACE,yBAAyB;EAC3B;;AAGF;AAEA;;AAEA;AAQA;;AAJI;MACE,yBAAyB;IAC3B;;AAIJ;AAEA;;AAEA;AAEA;;AAGE;IACE,iBAAiB;EACnB;;AAEA;IACE,aAAa;EACf;;AAGF;AAEA;;AAEA;AAEA;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AAEjC;;AAEA;EACE,mBAAmB;AAKrB;;AAHE;IACE,yDAA6D;EAC/D;;AAGF;;;EAGE,mDAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EAEE,kBAAkB;AAapB;;AAXE;IACE,mBAAmB;EACrB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAA+D;EAC/D,eAAe;AAQjB;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;AAQjB;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;AAEA;;AAEA;EAEE,iBAAiB;AACnB","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: \"styles/colors.css\";\n@value gtRed, gtGray, textLight from colors;\n\n.leaveNoteIcon {\n  background-image: url(\"styles/img/icon_leave_note.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 24px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 40px;\n  transition: background-color 0.25s;\n  width: 40px;\n\n  &:hover {\n    background-color: #E1DFE1;\n  }\n}\n\n.collapseIcon {\n  composes: collapseIcon from helpers;\n}\n\n.collapseRef {\n  composes: collapseRef from helpers;\n\n  &[data-active='true'] {\n    .collapseIcon {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.dropdownArea {\n  composes: dropdownArea from helpers;\n}\n\n.toggleLabel {\n  composes: toggleLabel from helpers;\n}\n\n.formItem {\n  textarea {\n    min-height: 100px;\n  }\n\n  label {\n    display: none;\n  }\n}\n\n.flexRow {\n  composes: flexRow from helpers;\n}\n\n.flexSB {\n  composes: flexSB from helpers;\n}\n\n.note {\n  padding-bottom: 10px;\n  font-weight: 500;\n  white-space: pre-wrap;\n}\n\n.notes {\n  list-style-type: none;\n  margin: 0;\n  overflow: auto;\n  padding: 0;\n}\n\n.noteWrapper {\n  background: white;\n  border-left: 4px solid gtYellow;\n  composes: noteWrapper from helpers;\n}\n\n.importantNoteWrapper {\n  background: #FDF1ED;\n\n  .important {\n    background-image: url(\"styles/img/icon-important-active.png\");\n  }\n}\n\n.important,\n.remove,\n.user {\n  color: textLight;\n  font-size: 12px;\n}\n\n.title {\n  flex: 1;\n}\n\n.titleSection {\n  composes: sectionTitle row from helpers;\n  position: relative;\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.user {\n  text-transform: capitalize;\n}\n\n.important {\n  margin-right: 15px;\n  background-position: center;\n  background-size: 13px;\n  background-repeat: no-repeat;\n  background-image: url(\"styles/img/icon-important-inactive.png\");\n  cursor: pointer;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.remove {\n  margin-left: 4px;\n  background-position: center;\n  background-size: 11px;\n  background-repeat: no-repeat;\n  background-image: url(\"styles/img/icon_close--gray.png\");\n  cursor: pointer;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 100%;\n    width: 24px;\n  }\n}\n\n.buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.removeBtn {\n  composes: buttonDanger from helpers;\n}\n\n.cancelBtn {\n  composes: button from helpers;\n  margin-left: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `"styles/colors.css"`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"leaveNoteIcon": `styles__leaveNoteIcon___Ci7Ps`,
	"collapseIcon": `styles__collapseIcon___T_4w6 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseIcon"]}`,
	"collapseRef": `styles__collapseRef___FMVZd ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseRef"]}`,
	"dropdownArea": `styles__dropdownArea___K_4_9 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["dropdownArea"]}`,
	"toggleLabel": `styles__toggleLabel___bKnxf ${___CSS_LOADER_ICSS_IMPORT_1___.locals["toggleLabel"]}`,
	"formItem": `styles__formItem___fQCDh`,
	"flexRow": `styles__flexRow___m6cS3 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexRow"]}`,
	"flexSB": `styles__flexSB___SnvLL ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexSB"]}`,
	"note": `styles__note___OO52t`,
	"notes": `styles__notes___xDJ1e`,
	"noteWrapper": `styles__noteWrapper___oCEFU ${___CSS_LOADER_ICSS_IMPORT_1___.locals["noteWrapper"]}`,
	"importantNoteWrapper": `styles__importantNoteWrapper___irbOP`,
	"important": `styles__important___Nhxqi`,
	"remove": `styles__remove___YWFCu`,
	"user": `styles__user___R_GFG`,
	"title": `styles__title___TUwX9`,
	"titleSection": `styles__titleSection___xdY8M ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"name": `styles__name___VmXsh`,
	"noName": `styles__noName___O10rr`,
	"buttons": `styles__buttons___oIhFB`,
	"removeBtn": `styles__removeBtn___CkM3p ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonDanger"]}`,
	"cancelBtn": `styles__cancelBtn___SGUQP ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`
};
export default ___CSS_LOADER_EXPORT___;
